
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/faq",
      function () {
        return require("private-next-pages/sub/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/faq"])
      });
    }
  